import { getTopSellers, getTopCustomers, getTopCustomersDetails, getTopSellersDetails, } from '@/services/stores/SalesRanking';
// fetch and format topSellersRanking
export const fetchTopSellersRanking = ({ filters }) => getTopSellers({ filters }).then(response => formatTopSellersResponse(response.data));
const formatTopSellersResponse = (response) => ({
    data: response?.data,
    errors: response?.errors,
    success: response?.success,
});
// fetch and format topCustomersRanking
export const fetchTopCustomersRanking = ({ filters }) => getTopCustomers({ filters }).then(response => formatTopCustomersResponse(response.data));
const formatTopCustomersResponse = (response) => ({
    data: response?.data,
    errors: response?.errors,
    success: response?.success,
});
// fetch and format topCustomersDetailRankingTable
export const fetchTopCustomersDetailRanking = ({ storeId, orderBy, limit, page, term, fileType, responseType, }) => getTopCustomersDetails({ storeId, orderBy, limit, page, term, fileType, responseType }).then(response => formatTopCustomersDetailResponse(response.data));
const formatTopCustomersDetailResponse = (response) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    export: response,
    data: response?.data,
    errors: response?.errors,
    series: response?.series,
    success: response?.success,
    totalCount: response?.totalCount,
});
// fetch and format topSellersDetailRankingTable
export const fetchTopSellersDetailRanking = ({ storeId, orderBy, limit, page, term, fileType, responseType, }) => getTopSellersDetails({ storeId, orderBy, limit, page, term, fileType, responseType }).then(response => formatTopSellersDetailResponse(response.data));
const formatTopSellersDetailResponse = (response) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    export: response,
    data: response?.data,
    errors: response?.errors,
    series: response?.series,
    success: response?.success,
    totalCount: response?.totalCount,
});
